var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigifiAuthLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 36,
    viewBox: "0 0 108 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9768 33.2977L34.2767 27.6556C34.5139 27.2298 34.5139 26.7188 34.2767 26.3143L33.2414 24.5259L27.72 33.979H29.8121C30.2866 33.979 30.7395 33.7235 30.9768 33.2977Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0241 33.2974L36.8221 31.9561C37.0593 31.5303 37.0593 31.0193 36.8221 30.6148L35.7868 28.8477L32.7673 34H34.8594C35.3123 33.9787 35.7653 33.7233 36.0241 33.2974Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21466 33.979L3.69329 24.5259L2.65804 26.3143C2.42079 26.7401 2.42079 27.2511 2.65804 27.6556L5.93635 33.2977C6.17359 33.7235 6.62652 33.979 7.12258 33.979H9.21466Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21319 28.7627L0.177935 30.5298C-0.0593116 30.9557 -0.0593116 31.4666 0.177935 31.8712L0.997513 33.2976C1.23476 33.7235 1.68768 33.9789 2.18375 33.9789H4.27583L1.21319 28.7627Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3119 33.9788H24.7648C25.2609 33.9788 25.7138 33.7233 25.951 33.2975L31.7743 23.3334C32.0116 22.9075 32.0116 22.3966 31.7743 21.992L30.7391 20.2036L23.4923 32.5736L24.3119 33.9788Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2401 33.9789L7.01483 21.6089H5.37567L5.15999 22.0134C4.92274 22.4392 4.92274 22.9502 5.15999 23.3547L10.9833 33.2975C11.2206 33.7234 11.6735 33.9789 12.1695 33.9789H14.2401Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.414 30.7422L29.251 19.0536C29.4883 18.6278 29.4883 18.1168 29.251 17.7123L28.2158 15.9238L20.9905 28.2938L22.414 30.7422Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17126 21.6089L16.0083 33.2975C16.2455 33.7234 16.6984 33.9789 17.1945 33.9789H19.2866L12.0398 21.6089H9.17126Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0872 21.6089H14.1971L21.0342 33.2975C21.2714 33.7234 21.7243 33.9789 22.2204 33.9789H24.3125L17.0872 21.6089Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7671 6.2583H15.1673C14.6713 6.2583 14.2399 6.51379 13.9811 6.93961L12.9243 8.70675H23.9886L22.9533 6.91832C22.6945 6.51379 22.2416 6.2583 21.7671 6.2583Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2869 2H17.6478C17.1517 2 16.7203 2.25549 16.4615 2.68131L15.4263 4.46974H21.5084L20.4731 2.68131C20.2359 2.25549 19.783 2 19.2869 2Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6928 11.6236L25.4556 11.2404C25.2183 10.8146 24.7654 10.5591 24.2693 10.5591H12.6227C12.1266 10.5591 11.6953 10.8146 11.4364 11.2404L10.4012 13.0288H24.8732L25.6928 11.6236Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7953 14.8594H10.1213C9.62521 14.8594 9.19385 15.1149 8.93504 15.5407L7.89978 17.3291H22.3718L23.7953 14.8594Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43256 19.8205L5.37573 21.6089H19.8478L21.2928 19.1392H7.61879C7.12273 19.1605 6.6698 19.4159 6.43256 19.8205Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6928 11.6235L18.4675 23.9935L19.9126 26.4632L26.7496 14.7746C26.9868 14.3488 26.9868 13.8378 26.7496 13.4333L25.6928 11.6235Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7227 9.30127C58.4199 9.30127 61.9105 12.3995 61.9105 17.6922C61.9105 22.985 58.3553 26.0831 53.6796 26.0831H47V9.30127H53.7227ZM49.6503 23.781H53.7011C56.9547 23.781 59.2387 21.694 59.2387 17.6922C59.2387 13.6904 56.9978 11.5819 53.7227 11.5819H49.6503V23.781Z",
    fill: "#404041"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8364 10.5711C67.8364 11.4532 67.1253 12.1417 66.2419 12.1417C65.38 12.1417 64.6689 11.4317 64.6689 10.5711C64.6689 9.71049 65.38 9.00049 66.2419 9.00049C67.1253 9.00049 67.8364 9.71049 67.8364 10.5711ZM64.9922 26.0621V14.5729H67.5132V26.0836L64.9922 26.0621Z",
    fill: "#404041"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7515 16.1862V14.5725H82.1217V26.6426C82.1217 29.9344 79.8808 31.9999 76.4548 31.9999C73.0288 31.9999 71.1758 30.2787 70.7233 27.7829L73.2443 27.6968C73.4598 29.0308 74.7095 29.8699 76.3902 29.8699C78.3078 29.8699 79.6007 28.8156 79.6007 26.8147V24.7062C78.9758 25.6098 77.6614 26.2983 75.9377 26.2983C72.7272 26.2983 70.4001 24.0177 70.4001 20.3386C70.4001 16.6595 72.7487 14.3789 75.9592 14.3789C77.7476 14.3789 79.1266 15.1319 79.7515 16.1862ZM72.9642 20.3386C72.9642 22.7914 74.4078 24.1468 76.3471 24.1468C78.2432 24.1468 79.6007 22.9204 79.6007 20.6398V20.0374C79.6007 17.7568 78.2216 16.5304 76.3471 16.5304C74.4078 16.5519 72.9642 17.8859 72.9642 20.3386Z",
    fill: "#404041"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5641 10.5711C88.5641 11.4532 87.853 12.1417 86.9696 12.1417C86.1077 12.1417 85.3967 11.4317 85.3967 10.5711C85.3967 9.71049 86.1077 9.00049 86.9696 9.00049C87.853 9.00049 88.5641 9.71049 88.5641 10.5711ZM85.7199 26.0621V14.5729H88.2409V26.0836L85.7199 26.0621Z",
    fill: "#404041"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6623 11.6469V16.3373H101.17V18.6824H94.6623V26.0621H91.9905V9.28027H102.549V11.6469H94.6623Z",
    fill: "#404041"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108 10.5711C108 11.4532 107.289 12.1417 106.406 12.1417C105.544 12.1417 104.833 11.4317 104.833 10.5711C104.833 9.71048 105.544 9.00048 106.406 9.00048C107.289 8.97896 108 9.68896 108 10.5496C108 10.5711 108 10.5711 108 10.5711ZM105.156 26.062V14.5729H107.677V26.0836L105.156 26.062Z",
    fill: "#404041"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 37.0459,
    y1: 26.5358,
    x2: 20.7817,
    y2: 34.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 38.7128,
    y1: 29.7595,
    x2: 22.5021,
    y2: 38.1648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 5.01954,
    y1: 34.2323,
    x2: 9.43169,
    y2: 13.0249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1.89405,
    y1: 33.6019,
    x2: 6.25778,
    y2: 12.6269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 35.3813,
    y1: 23.3201,
    x2: 19.102,
    y2: 31.7623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 8.19821,
    y1: 34.884,
    x2: 12.6251,
    y2: 13.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 33.2955,
    y1: 19.2973,
    x2: 17.014,
    y2: 27.7374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 12.5222,
    y1: 35.7714,
    x2: 16.949,
    y2: 14.4894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 17.344,
    y1: 36.7616,
    x2: 21.7709,
    y2: 15.4817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 11.6128,
    y1: 5.68221,
    x2: 30.2471,
    y2: 11.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 12.841,
    y1: 1.80408,
    x2: 31.4753,
    y2: 7.70254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 10.3749,
    y1: 9.59597,
    x2: 29.0092,
    y2: 15.4944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 8.99346,
    y1: 13.9646,
    x2: 27.6257,
    y2: 19.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 7.52805,
    y1: 18.5903,
    x2: 26.1602,
    y2: 24.4909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 31.0031,
    y1: 14.8817,
    x2: 14.7238,
    y2: 23.3218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigifiAuthLogoBlack);
export default __webpack_public_path__ + "static/media/digifi-auth-logo-black.f8cd470e.svg";
export { ForwardRef as ReactComponent };